// // import React, { useState, useEffect, Suspense } from "react";
// // import { Redirect, Route, Switch } from "react-router-dom";
// // import { Box, Spinner, useColorModeValue, Flex } from "@chakra-ui/react";
// // import { SidebarContext } from "contexts/SidebarContext";
// // import Sidebar from "components/sidebar/Sidebar";
// // import { getMenusForEmployee } from "api/menuService";
// // import { buildRoutes } from "routes";

// // export default function AdminLayout() {
// //   const [routes, setRoutes] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [toggleSidebar, setToggleSidebar] = useState(false);
// //   const bg = useColorModeValue("white", "navy.900");

// //   useEffect(() => {

// //     const empId = localStorage.getItem("empId") || 1; // fallback for test
// //     getMenusForEmployee(empId)
// //       .then((data) => {
// //         const built = buildRoutes(data);
// //         console.log("✅ Built Routes:", built);
// //         setRoutes(built);
// //       })
// //       .catch((err) => console.error("❌ Failed to fetch menus:", err))
// //       .finally(() => setLoading(false));
// //   }, []);

// //   const renderRoutes = (routes) =>
// //     routes.flatMap((r) =>
// //       r.children?.length
// //         ? renderRoutes(r.children)
// //         : r.path && r.component
// //         ? [
// //             <Route
// //               exact
// //               key={r.id}
// //               path={r.layout + r.path}
// //               component={r.component}
// //             />,
// //           ]
// //         : []
// //     );

// //   if (loading)
// //     return (
// //       <Flex align="center" justify="center" h="100vh" bg={bg}>
// //         <Spinner size="xl" color="blue.400" />
// //       </Flex>
// //     );

// //   if (!routes.length)
// //     return (
// //       <Flex align="center" justify="center" h="100vh" bg={bg}>
// //         <Box color="red.400" fontSize="lg">
// //           ❌ No menu routes loaded.
// //         </Box>
// //       </Flex>
// //     );

// //   return (
// //     <Box>
// //       <SidebarContext.Provider value={{ toggleSidebar, setToggleSidebar }}>
// //         <Sidebar routes={routes} />
// //         <Box
// //           bg={bg}
// //           ml={{ base: 0, xl: "300px" }}
// //           minH="100vh"
// //           transition="all 0.3s ease"
// //         >
// //           <Suspense fallback={<Spinner size="lg" />}>
// //             <Switch>
// //               {renderRoutes(routes)}
// //               <Redirect from="/admin" to="/admin/dashboard" />
// //             </Switch>
// //           </Suspense>
// //         </Box>
// //       </SidebarContext.Provider>
// //     </Box>
// //   );
// // }

// import React, { useState, useEffect, Suspense } from "react";
// import { Redirect, Route, Switch } from "react-router-dom";
// import {
//   Box,
//   Flex,
//   Spinner,
//   useDisclosure,
//   useColorModeValue,
//   Portal,
// } from "@chakra-ui/react";
// import { SidebarContext } from "contexts/SidebarContext";
// import Sidebar from "components/sidebar/Sidebar";
// import Navbar from "components/navbar/NavbarAdmin";
// import Footer from "components/footer/FooterAdmin";
// import { getMenusForEmployee } from "api/menuService";
// import { buildRoutes } from "routes";

// export default function AdminLayout() {
//   const [routes, setRoutes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [toggleSidebar, setToggleSidebar] = useState(false);
//   const { onOpen } = useDisclosure();
//   const bg = useColorModeValue("white", "navy.900");

//   // Fetch dynamic menus
//   useEffect(() => {
//     const storedUser = localStorage.getItem("user");
//     let empId = null;
//     try {
//       if (storedUser) {
//         const userObj = JSON.parse(storedUser);
//         empId = userObj?.id || userObj?.Id || null;
//       }
//     } catch (err) {
//       console.error("❌ Failed to parse user:", err);
//     }
//     if (!empId) empId = 1;

//     getMenusForEmployee(empId)
//       .then((data) => {
//         const built = buildRoutes(data);
//         console.log("✅ Built Routes:", built);
//         setRoutes(built);
//       })
//       .catch((err) => console.error("❌ Failed to fetch menus:", err))
//       .finally(() => setLoading(false));
//   }, []);

// const getActiveRoute = (routes, pathname = window.location.pathname) => {
//   for (const route of routes) {
//     if (route.children?.length) {
//       const nested = getActiveRoute(route.children, pathname);
//       if (nested !== "Dashboard") return nested;
//     }

//     // Normalize and check path match
//     if (route.layout && route.path) {
//       const fullPath = `${route.layout}${route.path}`;
//       const regexPath = new RegExp(
//         `^${fullPath.replace(/:\w+/g, "[^/]+")}$` // handles /user/:id style
//       );

//       if (regexPath.test(pathname)) {
//         return route.name || "Untitled";
//       }
//     }
//   }
//   return "Dashboard";
// };



//   const renderRoutes = (routes) =>
//     routes.flatMap((r) =>
//       r.children?.length
//         ? renderRoutes(r.children)
//         : r.layout === "/admin" && r.component
//         ? [
//             <Route
//               exact
//               key={r.id || r.path}
//               path={r.layout + r.path}
//               component={r.component}
//             />,
//           ]
//         : []
//     );

//   if (loading)
//     return (
//       <Flex align="center" justify="center" h="100vh" bg={bg}>
//         <Spinner size="xl" color="blue.400" />
//       </Flex>
//     );

//   if (!routes.length)
//     return (
//       <Flex align="center" justify="center" h="100vh" bg={bg}>
//         <Box color="red.400" fontSize="lg">
//           ❌ No menu routes loaded.
//         </Box>
//       </Flex>
//     );

//   return (
//     <Box>
//       <SidebarContext.Provider value={{ toggleSidebar, setToggleSidebar }}>
//         {/* Sidebar */}
//         <Sidebar routes={routes} />

//         {/* Main Content Area */}
//         <Box
//           float="right"
//           bg={bg}
//           minHeight="100vh"
//           height="100%"
//           overflow="auto"
//           position="relative"
//           maxHeight="100%"
//           w={{ base: "100%", xl: "calc(100% - 290px)" }}
//           maxWidth={{ base: "100%", xl: "calc(100% - 290px)" }}
//           transition="all 0.3s ease"
//         >
//           {/* ✅ Add Navbar (HeaderLinks inside) */}
//           <Portal>
//             <Box>
//               <Navbar
//                 onOpen={onOpen}
//                 logoText="Employee Portal"
//                // brandText="Dashboard"
//                 brandText={getActiveRoute(routes)} 
//                 secondary={false}
//                 fixed={false}
//                 routes={routes} // ✅ pass dynamic routes
//               />
//             </Box>
//           </Portal>

//           {/* Routes */}
//           <Box
//             mx="auto"
//             p={{ base: "20px", md: "30px" }}
//             pe="20px"
//             minH="100vh"
//             pt={{ base: "160px", md: "100px" }}
//           >
//             <Suspense
//               fallback={
//                 <Flex align="center" justify="center" h="100%">
//                   <Spinner size="lg" />
//                 </Flex>
//               }
//             >
//               <Switch>
//                 {renderRoutes(routes)}
//                 <Redirect from="/" to="/admin/dashboard" />
//               </Switch>
//             </Suspense>
//           </Box>

//           {/* Footer */}
//           <Footer />
//         </Box>
//       </SidebarContext.Provider>
//     </Box>
//   );
// }


// import React, { useState, useEffect, Suspense } from "react";
// import { Redirect, Route, Switch } from "react-router-dom";
// import { Box, Spinner, useColorModeValue, Flex } from "@chakra-ui/react";
// import { SidebarContext } from "contexts/SidebarContext";
// import Sidebar from "components/sidebar/Sidebar";
// import { getMenusForEmployee } from "api/menuService";
// import { buildRoutes } from "routes";

// export default function AdminLayout() {
//   const [routes, setRoutes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [toggleSidebar, setToggleSidebar] = useState(false);
//   const bg = useColorModeValue("white", "navy.900");

//   useEffect(() => {

//     const empId = localStorage.getItem("empId") || 1; // fallback for test
//     getMenusForEmployee(empId)
//       .then((data) => {
//         const built = buildRoutes(data);
//         console.log("✅ Built Routes:", built);
//         setRoutes(built);
//       })
//       .catch((err) => console.error("❌ Failed to fetch menus:", err))
//       .finally(() => setLoading(false));
//   }, []);

//   const renderRoutes = (routes) =>
//     routes.flatMap((r) =>
//       r.children?.length
//         ? renderRoutes(r.children)
//         : r.path && r.component
//         ? [
//             <Route
//               exact
//               key={r.id}
//               path={r.layout + r.path}
//               component={r.component}
//             />,
//           ]
//         : []
//     );

//   if (loading)
//     return (
//       <Flex align="center" justify="center" h="100vh" bg={bg}>
//         <Spinner size="xl" color="blue.400" />
//       </Flex>
//     );

//   if (!routes.length)
//     return (
//       <Flex align="center" justify="center" h="100vh" bg={bg}>
//         <Box color="red.400" fontSize="lg">
//           ❌ No menu routes loaded.
//         </Box>
//       </Flex>
//     );

//   return (
//     <Box>
//       <SidebarContext.Provider value={{ toggleSidebar, setToggleSidebar }}>
//         <Sidebar routes={routes} />
//         <Box
//           bg={bg}
//           ml={{ base: 0, xl: "300px" }}
//           minH="100vh"
//           transition="all 0.3s ease"
//         >
//           <Suspense fallback={<Spinner size="lg" />}>
//             <Switch>
//               {renderRoutes(routes)}
//               <Redirect from="/admin" to="/admin/dashboard" />
//             </Switch>
//           </Suspense>
//         </Box>
//       </SidebarContext.Provider>
//     </Box>
//   );
// }

import React, { useState, useEffect, Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  Box,
  Flex,
  Spinner,
  useDisclosure,
  useColorModeValue,
  Portal,
} from "@chakra-ui/react";
import { SidebarContext } from "contexts/SidebarContext";
import Sidebar from "components/sidebar/Sidebar";
import Navbar from "components/navbar/NavbarAdmin";
import Footer from "components/footer/FooterAdmin";
import { getMenusForEmployee } from "api/menuService";
import { buildRoutes } from "routes";
import { useLocation } from "react-router-dom";
import { logUserActivity } from "api/activityLogger";
const ChangePassword = lazy(() => import("views/admin/change_password/change_password.jsx"));





export default function AdminLayout() {
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const { onOpen } = useDisclosure();
  const bg = useColorModeValue("white", "navy.900");

  // Fetch dynamic menus
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    let empId = null;
    try {
      if (storedUser) {
        const userObj = JSON.parse(storedUser);
        empId = userObj?.id || userObj?.Id || null;
      }
    } catch (err) {
      console.error("❌ Failed to parse user:", err);
    }
    if (!empId) empId = 1;

    getMenusForEmployee(empId)
      .then((data) => {
        const built = buildRoutes(data);
        console.log("✅ Built Routes:", built);
        setRoutes(built);
      })
      .catch((err) => console.error("❌ Failed to fetch menus:", err))
      .finally(() => setLoading(false));
  }, []);

  const location = useLocation();
  // useEffect(() => {
  //   const storedUser = localStorage.getItem("user");
  //   if (storedUser) {
  //     try {
  //       const userObj = JSON.parse(storedUser);
  //       const empId = userObj?.id || userObj?.Id;
  //       if (empId) {
  //         console.log('empid' , empId);
  //         console.log('location',  location.pathname)
  //         console.log('component', location.component )
  //         logUserActivity(empId, location.pathname);

  //       }
  //     } catch (e) {
  //       console.error("User parse error", e);
  //     }
  //   }
  // }, [location.pathname]);




  const getActiveRoute = (routes, pathname) => {
    if (!routes?.length) return "Dashboard";

    const match = findActiveRoute(routes, pathname);
    if (match && match.breadcrumb?.length) {
      return match.breadcrumb.join(" / ");
    }
    return "Dashboard";
  };

  const findActiveRoute = (routes, pathname, trail = []) => {
    for (const route of routes) {
      const currentTrail = [...trail, route.name];
      const fullPath = `/admin${route.path || ""}`.replace(/\/+$/, "");

      // Match static and dynamic paths
      const regex = new RegExp(
        `^${fullPath.replace(/:\w+/g, "[^/]+")}$`,
        "i"
      );

      if (regex.test(pathname)) {
        return { ...route, breadcrumb: currentTrail };
      }

      if (route.children?.length) {
        const nested = findActiveRoute(route.children, pathname, currentTrail);
        if (nested) return nested;
      }
    }

    return null;
  };

  const activeTitle = getActiveRoute(routes, location.pathname);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const userObj = JSON.parse(storedUser);
        const empId = userObj?.id || userObj?.Id;
        if (empId) {
          const pageName = activeTitle; // ← "Applications / Leave Applications"
          console.log("Pagename", pageName);
          logUserActivity(empId, location.pathname, pageName);
        }
      } catch (e) {
        console.error("User parse error", e);
      }
    }
  }, [location.pathname, activeTitle]);




  const renderRoutes = (routes) =>
    routes.flatMap((r) =>
      r.children?.length
        ? renderRoutes(r.children)
        : r.layout === "/admin" && r.component
          ? [
            <Route
              exact
              key={r.id || r.path}
              path={r.layout + r.path}
              component={r.component}
            />,
          ]
          : []
    );

  if (loading)
    return (
      <Flex align="center" justify="center" h="100vh" bg={bg}>
        <Spinner size="xl" color="blue.400" />
      </Flex>
    );

  if (!routes.length)
    return (
      <Flex align="center" justify="center" h="100vh" bg={bg}>
        <Box color="red.400" fontSize="lg">
          ❌ No menu routes loaded.
        </Box>
      </Flex>
    );

  return (
    <Box>
      <SidebarContext.Provider value={{ toggleSidebar, setToggleSidebar }}>
        {/* Sidebar */}
        <Sidebar routes={routes} />

        {/* Main Content Area */}
        <Box
          float="right"
          bg={bg}
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={{ base: "100%", xl: "calc(100% - 290px)" }}
          maxWidth={{ base: "100%", xl: "calc(100% - 290px)" }}
          transition="all 0.3s ease"
        >


          {/* ✅ Add Navbar (HeaderLinks inside) */}
          <Portal>
            <Box>
              <Navbar
                onOpen={onOpen}
                logoText="Employee Portal"
                // brandText="Dashboard"
                // brandText={getActiveRoute(routes)} 
                brandText={activeTitle}
                secondary={false}
                fixed={false}
                routes={routes}  // ✅ pass dynamic routes

              />
            </Box>
          </Portal>

          {/* Routes */}
          <Box
            mx="auto"
            p={{ base: "20px", md: "30px" }}
            pe="20px"
            minH="100vh"
            pt={{ base: "160px", md: "100px" }}
          >
            <Suspense
              fallback={
                <Flex align="center" justify="center" h="100%">
                  <Spinner size="lg" />
                </Flex>
              }
            >
              <Switch>
                {renderRoutes(routes)}
                <Route
                  exact
                  path="/admin/change_password"
                  component={ChangePassword}
                />
                <Redirect from="/" to="/admin/dashboard" />
              </Switch>
            </Suspense>
          </Box>

          {/* Footer */}
          <Footer />
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
